import fetchIntercept from "fetch-intercept";

import { history } from "../routes/history";
import { store } from "../store";
import { APP_NO_PERMISSION_ROUTE, APP_SERVICE_UNAVAILABLE_ROUTE } from "../routes";
import { setUserLogout } from "../store/account";

fetchIntercept.register({
  response: function (response) {
    // Check if this request should skip redirection
    const skipRedirect =
      response.headers.get("X-Skip-Redirect") ||
      (response.request && response.request.headers && response.request.headers.get("X-Skip-Redirect"));

    if (skipRedirect === "true") {
      // Skip all redirect logic for this request
      return response;
    }

    if (response.status === 401) {
      // @ts-ignore AppThunk type issue, we should use event based middleware
      store.dispatch(setUserLogout());
    } else if (response.status === 403) {
      // Clone the response to avoid consuming the body
      const responseClone = response.clone();

      // Process the response and show the alert
      responseClone
        .json()
        .then(data => {
          // Extract message from response
          let message = "Access denied";
          if (data?.errors && data.errors.length > 0) {
            message = data.errors[0].message || message;
          } else if (data?.message) {
            message = data.message;
          }

          alert(message);
        })
        .catch(() => {
          // Fallback if JSON parsing fails
          alert("Access denied");
        });

      if (!window.electron) {
        history.push(APP_NO_PERMISSION_ROUTE);
      }
    } else if (response.status >= 500) {
      alert("Service is unavailable");
      if (!window.electron) {
        history.push(APP_SERVICE_UNAVAILABLE_ROUTE);
      }
    }

    return response;
  },
});
